import messageBox from "../reducers/messageBox"

export function showModal(modalOptions){
   // console.log("modalOptions",modalOptions)
    let defaults = {
        type: "", 
        title: "", 
        message: "", 
        timeout: 5000, 
        buttonArray: ["OK"],  
        onClick: (btnIndex)=>(btnIndex),
        shown: true,
        autoClose: true,
        isDate:false,
        isJson:false,
        dateVal:"",
        data:{}
    }

    return {
        type: 'SHOW_MODAL',
        customModal: {
            ...defaults,
            ...modalOptions
        }
    }
}

export function closeModal(){
    return {
        type: 'CLOSE_MODAL',
        customModal: {
            shown: false
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/customModal.js